<template>
  <v-sheet class="d-flex flex-column" color="#fef7f3" min-height="100dvh">
    <template v-if="loading">
      <v-row class="fill-height ma-0" align="center" justify="center">
        <v-progress-circular
          indeterminate
          color="grey lighten-5"
        ></v-progress-circular>
      </v-row>
    </template>

    <template v-else>
      <template v-if="fazenda">
        <header class="header">
          <img class="d-block header-image" :src="bg" />

          <div class="header-caption">
            <template
              v-if="
                domain !== 'fazendas' ||
                (domain === 'fazendas' && fazenda.informacoes.tipo_imovel !== 6)
              "
            >
              <v-container class="link-page">
                <div class="d-flex justify-center justify-sm-start">
                  <img
                    class="d-block"
                    :src="logo"
                    :height="
                      !xsOnly ? (domain === 'fazendas' ? '70px' : '100px') : ''
                    "
                    :width="xsOnly ? '70%' : ''"
                  />
                </div>
              </v-container>
            </template>
          </div>
        </header>

        <div class="content">
          <template v-if="fazenda.informacoes">
            <v-container class="link-page">
              <!-- <LinkTitleWidget> Informações </LinkTitleWidget> -->

              <div v-if="fazenda?.created_at" class="d-flex text-body-2 mb-2">
                <template v-if="fazenda.link_nome">
                  <div class="font-weight-medium">
                    {{ fazenda.link_nome }}
                  </div>

                  <div class="mx-2">•</div>
                </template>

                <div class="font-weight-regular">
                  {{ formatDate(fazenda.created_at) }}
                </div>
              </div>

              <div class="grid-list-informations">
                <LinkInformationCard
                  v-for="(item, key) in informations"
                  :class="{
                    'full-column':
                      xsOnly && ['Nome', 'Valor Total'].includes(item.title),
                  }"
                  v-bind="item"
                  :key="item.title + '-' + key"
                />
              </div>
            </v-container>
          </template>

          <template v-if="highlightedImage && highlightedImage.url">
            <v-container class="mt-6 mt-md-10 px-0 px-lg-3 link-page">
              <v-img
                class="d-block"
                :height="!xsOnly ? '400px' : ''"
                :src="highlightedImage.url"
                width="100%"
              />
            </v-container>
          </template>

          <template v-if="fazenda.mapa && fazenda.mapa.length">
            <v-container class="mt-6 mt-md-10 px-0 px-lg-3 link-page">
              <LinkTitleWidget class="px-3 px-lg-0">
                <div class="d-flex align-end justify-space-between">
                  Localização

                  <template v-if="fazenda.mapa[0].url">
                    <v-btn
                      @click="$emit('bundle-kmz')"
                      color="primary"
                      height="32px"
                      outlined
                      small
                    >
                      <v-icon class="mr-2" size="18"> mdi-download </v-icon>
                      <div class="text-none">Baixar KMZ</div>
                    </v-btn>
                  </template>
                </div>
              </LinkTitleWidget>

              <div
                v-if="fazenda?.city"
                class="d-flex align-center px-3 px-lg-0 mt-4"
              >
                <v-icon class="mr-1" color="black" size="18">
                  mdi-map-marker-outline
                </v-icon>

                <div class="black--text text-subtitle-1 font-weight-medium">
                  {{ `${fazenda.city}/${fazenda.state}` }}
                </div>
              </div>

              <PolygonMap class="mt-5" :coordinates="[...fazenda.mapa]" />
            </v-container>
          </template>

          <template v-if="fazenda.informacoes_diversas">
            <v-container class="mt-6 mt-md-10 link-page">
              <!-- <LinkTitleWidget>Informações diversas</LinkTitleWidget>

              <div
                class="mt-4 mt-md-8 rich-text"
                v-html="fazenda.informacoes_diversas"
              ></div> -->

              <div
                class="rich-text"
                v-html="fazenda.informacoes_diversas"
              ></div>
            </v-container>
          </template>

          <template v-if="fazenda.benfeitorias">
            <v-container class="mt-6 mt-md-10 link-page">
              <!-- <LinkTitleWidget>Benfeitorias</LinkTitleWidget>

              <div
                class="mt-4 mt-md-8 rich-text"
                v-html="fazenda.benfeitorias"
              ></div> -->

              <div class="rich-text" v-html="fazenda.benfeitorias"></div>
            </v-container>
          </template>

          <template
            v-if="
              fazenda.documentos_ambientais &&
              fazenda.documentos_ambientais.length
            "
          >
            <v-container class="mt-6 mt-md-10 link-page">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="on"
                    @click="showAmb = !showAmb"
                    class="d-inline-flex align-center cursor-pointer"
                  >
                    <LinkTitleWidget>
                      Documentos Ambientais ({{
                        fazenda.documentos_ambientais.length
                      }})
                    </LinkTitleWidget>

                    <v-btn class="ml-2" color="black" icon>
                      <v-icon :size="xsOnly ? 24 : 30">mdi-chevron-down</v-icon>
                    </v-btn>
                  </div>
                </template>

                <span>{{ showAmb ? "Recolher" : "Expandir" }}</span>
              </v-tooltip>

              <v-expand-transition>
                <div v-show="showAmb">
                  <div class="mt-4 mt-md-8 grid-list-files">
                    <LinkFileCard
                      v-for="(item, key) in fazenda.documentos_ambientais"
                      :key="`${
                        item.name || item.url
                      }-${key}-documentos_ambientais`"
                      v-bind="item"
                    />
                  </div>
                </div>
              </v-expand-transition>
            </v-container>
          </template>

          <template
            v-if="
              fazenda.documentos_diversos && fazenda.documentos_diversos.length
            "
          >
            <v-container class="mt-6 mt-md-10 link-page">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="on"
                    @click="showDiv = !showDiv"
                    class="d-inline-flex align-center cursor-pointer"
                  >
                    <LinkTitleWidget>
                      Documentos Diversos ({{
                        fazenda.documentos_diversos.length
                      }})
                    </LinkTitleWidget>

                    <v-btn class="ml-2" color="black" icon>
                      <v-icon :size="xsOnly ? 24 : 30">mdi-chevron-down</v-icon>
                    </v-btn>
                  </div>
                </template>

                <span>{{ showDiv ? "Recolher" : "Expandir" }}</span>
              </v-tooltip>

              <v-expand-transition>
                <div v-show="showDiv">
                  <div class="mt-4 mt-md-8 grid-list-files">
                    <LinkFileCard
                      v-for="(item, key) in fazenda.documentos_diversos"
                      :key="`${
                        item.name || item.url
                      }-${key}-documentos_diversos`"
                      v-bind="item"
                    />
                  </div>
                </div>
              </v-expand-transition>
            </v-container>
          </template>

          <template
            v-if="
              fazenda.documentos_fundiarios &&
              fazenda.documentos_fundiarios.length
            "
          >
            <v-container class="mt-6 mt-md-10 link-page">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="on"
                    @click="showFund = !showFund"
                    class="d-inline-flex align-center cursor-pointer"
                  >
                    <LinkTitleWidget>
                      Documentos Fundiários ({{
                        fazenda.documentos_fundiarios.length
                      }})
                    </LinkTitleWidget>

                    <v-btn class="ml-2" color="black" icon>
                      <v-icon :size="xsOnly ? 24 : 30">mdi-chevron-down</v-icon>
                    </v-btn>
                  </div>
                </template>

                <span>{{ showFund ? "Recolher" : "Expandir" }}</span>
              </v-tooltip>

              <v-expand-transition>
                <div v-show="showFund">
                  <div class="mt-4 mt-md-8 grid-list-files">
                    <LinkFileCard
                      v-for="(item, key) in fazenda.documentos_fundiarios"
                      :key="`${
                        item.name || item.url
                      }-${key}-documentos_fundiarios`"
                      v-bind="item"
                    />
                  </div>
                </div>
              </v-expand-transition>
            </v-container>
          </template>

          <template v-if="fazenda.contacts && fazenda.contacts.length">
            <v-container class="mt-6 mt-md-10 link-page">
              <LinkTitleWidget>Envolvidos</LinkTitleWidget>

              <v-data-table
                class="mt-4 mt-md-8 table-contact"
                :headers="headerContacts"
                :items="fazenda.contacts"
                hide-default-footer
                disable-sort
              >
                <template v-slot:item="{ item, headers }">
                  <tr :class="{ bordered: !item.observation }">
                    <td>{{ item.name }}</td>
                    <td>{{ maskCpfCnpj(item.cpf_cnpj) }}</td>
                    <td>{{ maskPhone(item.phone) }}</td>
                    <td>{{ item.email }}</td>
                  </tr>

                  <tr v-if="item.observation" class="bordered">
                    <td
                      :colspan="headers.length"
                      style="height: auto; padding-bottom: 15px"
                    >
                      <div class="text" v-html="item.observation"></div>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-container>
          </template>

          <template v-if="fazenda.fotos && fazenda.fotos.length">
            <v-container class="mt-6 mt-md-10 link-page">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="on"
                    @click="showPhotos = !showPhotos"
                    class="d-inline-flex align-center cursor-pointer"
                  >
                    <LinkTitleWidget>
                      Arquivos de Fotos ({{ fazenda.fotos.length }})
                    </LinkTitleWidget>

                    <v-btn class="ml-2" color="black" icon>
                      <v-icon :size="xsOnly ? 24 : 30">mdi-chevron-down</v-icon>
                    </v-btn>
                  </div>
                </template>

                <span>{{ showPhotos ? "Recolher" : "Expandir" }}</span>
              </v-tooltip>

              <v-expand-transition>
                <div v-show="showPhotos">
                  <div class="mt-4 mt-md-8 grid-list-photos">
                    <template v-for="(item, key) in fazenda.fotos">
                      <div
                        @click.prevent="showGallery(key)"
                        :key="`${item.name || item.url}-${key}-fotos`"
                      >
                        <LinkImageCard style="cursor: pointer" v-bind="item" />
                      </div>
                    </template>
                  </div>
                </div>
              </v-expand-transition>
            </v-container>
          </template>

          <template
            v-if="fazenda.videos_youtube && fazenda.videos_youtube.length"
          >
            <v-container class="mt-6 mt-md-10 link-page">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="on"
                    @click="showYou = !showYou"
                    class="d-inline-flex align-center cursor-pointer"
                  >
                    <LinkTitleWidget>
                      Vídeos do YouTube ({{ fazenda.videos_youtube.length }})
                    </LinkTitleWidget>

                    <v-btn class="ml-2" color="black" icon>
                      <v-icon :size="xsOnly ? 24 : 30">mdi-chevron-down</v-icon>
                    </v-btn>
                  </div>
                </template>

                <span>{{ showYou ? "Recolher" : "Expandir" }}</span>
              </v-tooltip>

              <v-expand-transition>
                <div v-show="showYou">
                  <div class="mt-4 mt-md-8 grid-list-videos">
                    <LinkVideoYoutubeCard
                      v-for="(item, key) in fazenda.videos_youtube"
                      :key="`${item.name || item.url}-${key}-videos-youtube`"
                      v-bind="item"
                    />
                  </div>
                </div>
              </v-expand-transition>
            </v-container>
          </template>

          <template v-if="fazenda.videos && fazenda.videos.length">
            <v-container class="mt-6 mt-md-10 link-page">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="on"
                    @click="showVid = !showVid"
                    class="d-inline-flex align-center cursor-pointer"
                  >
                    <LinkTitleWidget>
                      Arquivos de Vídeos ({{ fazenda.videos.length }})
                    </LinkTitleWidget>

                    <v-btn class="ml-2" color="black" icon>
                      <v-icon :size="xsOnly ? 24 : 30">mdi-chevron-down</v-icon>
                    </v-btn>
                  </div>
                </template>

                <span>{{ showVid ? "Recolher" : "Expandir" }}</span>
              </v-tooltip>

              <v-expand-transition>
                <div v-show="showVid">
                  <div class="mt-4 mt-md-8 grid-list-videos">
                    <LinkVideoCard
                      v-for="(item, key) in fazenda.videos"
                      :key="`${item.name || item.url}-${key}-videos`"
                      v-bind="item"
                    />
                  </div>
                </div>
              </v-expand-transition>
            </v-container>
          </template>
        </div>
      </template>

      <template v-else>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <div class="text-center">
            <div class="text-h3 font-weight-bold mb-4">Ops!</div>
            <div class="text-h6 mb-1">
              Não encontramos a área que você está procurando.
            </div>

            <div class="text-subtitle-1 mb-4">
              Entre em contato com quem compartilhou o link para mais
              informações.
            </div>
          </div>
        </v-row>
      </template>

      <div class="mt-auto">
        <v-divider class="mt-6 mt-md-10" />

        <div class="black--text text-body-2 text-center py-6">
          {{ copyright }}
        </div>
      </div>
    </template>

    <LinkCookieBannerWidget />
    <GalleryWidget />
  </v-sheet>
</template>

<script>
import LinkTitleWidget from "@/components/widgets/link/Title.vue";
import LinkInformationCard from "@/components/cards/link/Information.vue";
import PolygonMap from "@/components/PolygonMap.vue";
import LinkFileCard from "@/components/cards/link/File.vue";
import LinkImageCard from "@/components/cards/link/Image.vue";
import LinkVideoCard from "@/components/cards/link/Video.vue";
import LinkVideoYoutubeCard from "@/components/cards/link/VideoYoutube.vue";
import LinkCookieBannerWidget from "@/components/widgets/link/CookieBanner.vue";
import GalleryWidget from "@/components/widgets/Gallery.vue";
import formatPurpose from "@/utils/formatPurpose";
import formatPropertyType from "@/utils/formatPropertyType";
import formatArea from "@/utils/formatArea";
import maskCpfCnpj from "@/utils/maskCpfCnpj";
import maskPhone from "@/utils/maskPhone";
import formatDate from "@/utils/formatDate";
import currency from "currency.js";
import { server } from "@/config.js";

export default {
  components: {
    LinkTitleWidget,
    LinkInformationCard,
    PolygonMap,
    LinkFileCard,
    LinkImageCard,
    LinkVideoCard,
    LinkVideoYoutubeCard,
    LinkCookieBannerWidget,
    GalleryWidget,
  },
  props: {
    loading: Boolean,
    fazenda: {
      type: [Object, null],
      default: null,
    },
  },
  data: () => ({
    icons: ["mdi-facebook", "mdi-twitter", "mdi-linkedin", "mdi-instagram"],
    headerContacts: [
      {
        text: "Nome",
        align: "start",
        value: "name",
      },
      {
        text: "CPF/CNPJ",
        align: "start",
        value: "cpf_cnpj",
      },
      {
        text: "Telefone",
        align: "start",
        value: "phone",
      },
      {
        text: "E-mail",
        align: "start",
        value: "email",
      },
    ],
    isLoadingFile: false,
    showPhotos: true,
    showFund: true,
    showAmb: true,
    showDiv: true,
    showVid: true,
    showYou: true,
  }),
  computed: {
    domain() {
      if (server.includes("saojose")) return "saojose";
      else if (server.includes("platano")) return "platano";
      else return "fazendas";
    },
    bg() {
      switch (this.domain) {
        case "saojose":
          return "/img/bg-fazenda.jpg";
        default:
          return "/img/bg-fazenda.png";
      }
    },
    logo() {
      switch (this.domain) {
        case "saojose":
          return "/img/sao-jose.png";
        case "platano":
          return "/img/platano.png";
        default:
          return "/img/canto-a-canto-fazendas-white.png";
      }
    },
    highlightedImage() {
      return this.fazenda.fotos.find(({ is_cover }) => is_cover === 1);
    },
    copyright() {
      const initialYear = this.domain === "fazendas" ? 2023 : null;
      const year = new Date().getFullYear();

      let name = "";

      switch (this.domain) {
        case "saojose":
          name = "Construtora São José";
          break;
        case "platano":
          name = "Plátano Empreendimentos";
          break;
        default:
          name = "Canto a Canto Imóveis";
      }

      return `© ${
        (initialYear && initialYear > 0 ? initialYear + "-" : "") + year
      } ${name}. Todos os direitos reservados.`;
    },
    informations() {
      const informations = [];

      const r = this.fazenda.informacoes;

      if (r.nome)
        informations.push({
          title: "Nome",
          text: r.nome,
        });

      if (r.valor_total && r.valor_total !== "0.00")
        informations.push({
          title: "Valor Total",
          text: this.getCurrency(parseFloat(r.valor_total)),
        });

      if (r.tipo_imovel)
        informations.push({
          title: "Tipo",
          text: formatPropertyType(r.tipo_imovel),
        });

      if (r.cultura_desenv)
        informations.push({
          title: "Finalidade",
          text: formatPurpose(r.cultura_desenv),
        });

      if (r.area_total)
        informations.push({
          title: "Área Total",
          text: formatArea(r.sistema_metrico, r.area_total),
        });

      if (r.area_aberta)
        informations.push({
          title: "Área Aberta",
          text: formatArea(r.sistema_metrico, r.area_aberta),
        });

      return informations;
    },
    gallery() {
      let gallery = [];

      if (this.fazenda && this.fazenda.fotos && this.fazenda.fotos.length)
        gallery = this.fazenda.fotos.map(({ url }) => {
          return url;
        });

      return gallery;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getCurrency(value) {
      return currency(value, {
        separator: ".",
        decimal: ",",
        symbol: "R$ ",
      }).format();
    },
    showGallery(index) {
      window.showGalleryWidget(this.gallery, index);
    },
    maskCpfCnpj,
    maskPhone,
    formatDate,
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;

  &-image {
    aspect-ratio: 16 / 4;
    min-height: 300px;
    object-fit: cover;
    object-position: top center;
    pointer-events: none;
    width: 100%;
  }

  &-caption {
    align-items: center;
    background: linear-gradient(
      to bottom,
      rgba(254, 247, 243, 0) 0%,
      rgba(254, 247, 243, 0.15) 30%,
      rgba(254, 247, 243, 0.4) 55%,
      rgba(254, 247, 243, 0.7) 75%,
      rgba(254, 247, 243, 1) 100%
    );
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    padding-bottom: 60px;
    pointer-events: visible;
    position: absolute;
    top: 0;
    width: 100%;
  }
}

.content {
  margin-top: -100px;
  position: relative;
  z-index: 2;
}

.grid-list-informations {
  $columns: 3;
  $gap: 24px;

  display: grid;
  gap: $gap;
  grid-template-columns: repeat(
    $columns,
    calc((100% / $columns) - ($gap * ($columns - 1) / $columns))
  );

  @media screen and (max-width: 959.9px) {
    $columns: 2;
    $gap: 12px;

    gap: $gap;
    grid-template-columns: repeat(
      $columns,
      calc((100% / $columns) - ($gap * ($columns - 1) / $columns))
    );
  }
}

.grid-list-files {
  $columns: 4;
  $gap: 24px;

  display: grid;
  gap: $gap;
  grid-template-columns: repeat(
    $columns,
    calc((100% / $columns) - ($gap * ($columns - 1) / $columns))
  );

  @media screen and (max-width: 1279.9px) {
    $columns: 3;

    grid-template-columns: repeat(
      $columns,
      calc((100% / $columns) - ($gap * ($columns - 1) / $columns))
    );
  }

  @media screen and (max-width: 959.9px) {
    $columns: 2;
    $gap: 12px;

    gap: $gap;
    grid-template-columns: repeat(
      $columns,
      calc((100% / $columns) - ($gap * ($columns - 1) / $columns))
    );
  }
}

.grid-list-photos {
  $columns: 4;
  $gap: 24px;

  display: grid;
  gap: $gap;
  grid-template-columns: repeat(
    $columns,
    calc((100% / $columns) - ($gap * ($columns - 1) / $columns))
  );

  @media screen and (max-width: 1279.9px) {
    $columns: 3;

    grid-template-columns: repeat(
      $columns,
      calc((100% / $columns) - ($gap * ($columns - 1) / $columns))
    );
  }

  @media screen and (max-width: 959.9px) {
    $columns: 2;
    $gap: 12px;

    gap: $gap;
    grid-template-columns: repeat(
      $columns,
      calc((100% / $columns) - ($gap * ($columns - 1) / $columns))
    );
  }
}

.grid-list-videos {
  $columns: 3;
  $gap: 24px;

  display: grid;
  gap: $gap;
  grid-template-columns: repeat(
    $columns,
    calc((100% / $columns) - ($gap * ($columns - 1) / $columns))
  );

  @media screen and (max-width: 1279.9px) {
    $columns: 2;

    grid-template-columns: repeat(
      $columns,
      calc((100% / $columns) - ($gap * ($columns - 1) / $columns))
    );
  }

  @media screen and (max-width: 959.9px) {
    $gap: 12px;

    gap: $gap;
    grid-template-columns: repeat(
      $columns,
      calc((100% / $columns) - ($gap * ($columns - 1) / $columns))
    );
  }

  @media screen and (max-width: 599.9px) {
    $columns: 1;

    grid-template-columns: repeat(
      $columns,
      calc((100% / $columns) - ($gap * ($columns - 1) / $columns))
    );
  }
}

.full-column {
  grid-column: 1 / -1;
}

.rich-text::v-deep {
  @media screen and (min-width: 960px) {
    ul {
      columns: 2;
      column-gap: 32px;
    }

    li {
      break-inside: avoid;
    }
  }

  li {
    margin-bottom: 4px;

    &::marker {
      font-size: 0.6em;
    }
  }
}

.table-contact::v-deep {
  $border-color: #dbdee1;

  .v-data-table__wrapper {
    background-color: #f3f5f6;
    border-left: 1px solid $border-color;
    border-right: 1px solid $border-color;

    > table {
      > thead {
        > tr {
          > th {
            background-color: #f3f5f6;
            border-bottom: 1px solid $border-color !important;
            border-top: 1px solid $border-color;
            box-shadow: none;
            color: var(--v-secondary-base);
            font-size: 14px;
            font-weight: 500;
          }
        }
      }

      > tbody {
        > tr {
          &:not(.bordered) {
            > td {
              border-bottom: 0 !important;
            }
          }

          > td {
            background-color: #ffffff;
          }

          @media screen and (min-width: 960px) {
            &.bordered {
              > td {
                border-bottom: 1px solid $border-color;
              }
            }
          }
        }
      }
    }
  }
}

.text::v-deep {
  p:last-child {
    margin-bottom: 0;
  }
}
</style>
